module.exports = __webpack_public_path__ + "assets/redirect-to-new-tab.71a824d2.svg";